import React from 'react';
import {
  AssemblyType,
  AssemblyTypeKey,
  RpCheck2Type,
  TestRepair,
  TestResult,
  TestResultDc,
  TestResultRp,
  TestResultSvbPvb,
  TestResultType2Bypass,
} from '@ecosconnect/core/src/types/jobFormData';
import Accordion from '../../Accordion/Accordion';
import AccordionItem from '../../Accordion/AccordionItem';
import { validateTestResult } from '@ecosconnect/core/src/helpers/backflow/validate';
import RpTestResult from './types/RpTestResult';
import DcTestResult from './types/DcTestResult';
import SvbPvbTestResult from './types/SvbPvbTestResult';
import Type2BypassTestResult from './types/Type2BypassTestResult';
import BackflowTestResultStatus from './BackflowTestResultStatus';
import backflowTestResultTitle from './backflowTestResultTitle';
import { Text } from 'rebass';

type BackflowTestResultProps = {
  test: TestResult | TestRepair;
  assemblyType: AssemblyTypeKey;
  rpCheck2Type: RpCheck2Type;
  index: number;
};

const BackflowTestResult: React.FC<BackflowTestResultProps> = ({
  test,
  assemblyType,
  rpCheck2Type,
  index,
}) => {
  if (test.type === 'repair') {
    return (
      <Accordion
        key={index}
        title={`Repair` + (test.testDate ? ` - ${test.testDate}` : '')}
      >
        {!!test.comment && (
          <AccordionItem label="Comments" value={test.comment} />
        )}
      </Accordion>
    );
  }

  const errors = validateTestResult(test, AssemblyType[assemblyType]);

  return (
    <Accordion
      title={backflowTestResultTitle({
        testDate: test.testDate,
        assemblyType,
        index,
      })}
      icon={
        <BackflowTestResultStatus
          test={test}
          assemblyType={assemblyType}
          rpCheck2Type={rpCheck2Type}
        />
      }
    >
      {!!test.systemPsi && (
        <AccordionItem required label="System PSI" value={test.systemPsi} />
      )}
      {assemblyType.startsWith('RP') && (
        <RpTestResult test={test as TestResultRp} />
      )}
      {assemblyType.startsWith('DC') && (
        <DcTestResult test={test as TestResultDc} />
      )}
      {assemblyType === 'TYPE_2_BYPASS' && (
        <Type2BypassTestResult test={test as TestResultType2Bypass} />
      )}
      {['PVB', 'SVG'].includes(assemblyType) && (
        <SvbPvbTestResult test={test as TestResultSvbPvb} />
      )}
      {errors.map((error, index) => (
        <Text variant="validation" key={index}>
          {error}
        </Text>
      ))}
    </Accordion>
  );
};

export default BackflowTestResult;
